import React, { useState, useEffect } from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import api from "../../utils/api";

const DomainChart = ({ queryParams }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/api/analytics/domains?${queryParams}`)
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [queryParams]);

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status" />
      </div>
    );
  }

  if (data.length === 0) {
    return <p className="text-muted text-center">No domain data yet — scans will appear here once the domain tracking is live.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" tick={{ fontSize: 12 }} />
        <YAxis />
        <Tooltip />
        <Legend />
        <Area
          type="monotone"
          dataKey="machimpex"
          stackId="1"
          stroke="#94a3b8"
          fill="#94a3b8"
          fillOpacity={0.6}
          name="qr.machimpex.com"
        />
        <Area
          type="monotone"
          dataKey="thinkclean"
          stackId="1"
          stroke="#6366f1"
          fill="#6366f1"
          fillOpacity={0.6}
          name="qr.thinkclean.com"
        />
        <Area
          type="monotone"
          dataKey="other"
          stackId="1"
          stroke="#e2e8f0"
          fill="#e2e8f0"
          fillOpacity={0.6}
          name="Other/Unknown"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default DomainChart;
